import React from 'react';
import { IconProps } from '../types/types';

const LGCY: React.FC<IconProps> = (props) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 195 195" role="img" {...props}><circle cx="97.5" cy="97.5" r="97.5" fill="#202020"/><path d="M38 143 95 25v57m-57 61 57 27.5V82m-57 61 57-61M158 143 101 25v57m57 61-57 27.5V82m57 61-57-61" stroke="#fff" strokeWidth="2" strokeLinejoin="round"/></svg>
);

export default LGCY;
